import { Modal, Container } from "react-bootstrap";
import React from "react";

function EditModal(props) {
  // const [editData, setEditData] = useState({});
  // const handleEditChange = (e) => {
  //   const {name,value} = e.target;
  //   // setEditData((prev)=>{...prev, name: [value]})
  // }
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered backdrop="static">
        <Modal.Header />
        <Modal.Body>
          <div className="col-sm-12">
            <text className="custom-modal-body-title">
              {" "}
              EDIT {props.title}{" "}
            </text>
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-secondary me-3" onClick={props.onHide}>
                Cancel
              </button>
              <button className="button-primary" onClick={props.onSave}>
                Save
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

EditModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default EditModal;
